import type { Composer } from 'vue-i18n';
import { setGlobalComposer } from '@cvo/i18n/composables/useI18n';

/** Lets useI18n() resolve the global composer outside component setup (middlewares, stores, plugins). */
export default defineNuxtPlugin({
  name: 'i18n-global',
  dependsOn: ['i18n:plugin'],
  setup(nuxtApp) {
    setGlobalComposer(nuxtApp.$i18n as Composer);
  },
});
